import { UnderstandUserRolesButton } from '@modules/users/components/UnderstandUserRolesButton';
import { UsersTable } from '@modules/users/components/UsersTable';
import { WorkspaceSettingsItem } from '@modules/workspaceSettings/components/WorkspaceSettingsItem';
import { useIsUserRolesEnabled } from '@modules/workspaceSettings/hooks';
import { SupervisorAccountRounded } from '@mui/icons-material';
import { Divider, Paper, Stack } from '@mui/material';
import { AutoApproveUsersSelect } from './AutoApproveUsersSelect';
import { DefaultUserRolesSelect } from './DefaultUserRolesSelect';

export const Users = () => {
  const isUserRolesEnabled = useIsUserRolesEnabled();

  const renderWorkspaceSecondaryContent = () => {
    return (
      <Paper
        variant="outlined"
        sx={{
          borderRadius: 2,
          px: 3,
          py: 3.5,
        }}
      >
        <Stack direction="row" spacing={2}>
          <Stack flex={1}>
            <DefaultUserRolesSelect />
          </Stack>
          <Divider orientation="vertical" />
          <Stack flex={1} justifyContent="center">
            <AutoApproveUsersSelect />
          </Stack>
        </Stack>
      </Paper>
    );
  };

  return (
    <WorkspaceSettingsItem
      icon={<SupervisorAccountRounded sx={{ color: 'text.secondary' }} />}
      title="Users"
      titleAction={<UnderstandUserRolesButton />}
      secondaryNode={
        isUserRolesEnabled ? renderWorkspaceSecondaryContent() : null
      }
    >
      <UsersTable />
    </WorkspaceSettingsItem>
  );
};
